import { forwardRef, HTMLProps } from "react";

import Typography from "@/components/Typography";
import { cx } from "@/utils";

import styles from "./Radio.module.css";

export interface RadioProps extends React.HTMLProps<HTMLInputElement> {
  className?: string;
  block?: boolean;
  disabled?: boolean;
  label?: string;
  wrapLabel?: boolean;
}

export const RadioIndicator = ({
  className,
  ...props
}: HTMLProps<HTMLSpanElement>) => (
  <span className={cx(styles.faux, styles.className, className)} {...props} />
);

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ disabled, label = null, wrapLabel = false, className, ...props }, ref) => {
    return (
      <label
        className={cx(
          styles.root,
          {
            [styles.noWrapLabel]: wrapLabel === false,
            [styles.disabled]: disabled,
          },
          className
        )}
      >
        <input
          className={styles.input}
          disabled={disabled}
          aria-disabled={disabled}
          type="radio"
          ref={ref}
          {...props}
        />
        <RadioIndicator data-testid={`input-span-${props.value}`} />
        {label && (
          <Typography variant="body-2" className={styles.label} margin="none">
            {label}
          </Typography>
        )}
      </label>
    );
  }
);

Radio.displayName = "Radio";
export default Radio;
